module.exports = __webpack_public_path__ + "img/20191202173410585.3fe06eda.jpg";